export default "__VITE_ASSET__Bk70HoVW__"